'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('activation-code-list', {
      url: '/admin/code/list',
      template: '<activation-code-list></activation-code-list>',
      authenticate: 'admin'
    });
}



// WEBPACK FOOTER //
// ./client/app/admin/activation-code/list/code-list.routes.js